import { UserRoleDto } from '@/api/generated';

import { RouteEnum } from './Route.model';

export const ROUTES_ROLES: Partial<Record<RouteEnum, UserRoleDto[]>> = {
  [RouteEnum.ADMINISTRATION]: [UserRoleDto.Admin],
};
